"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetUserStatus = exports.GET_USER_STATUS = void 0;
const client_1 = require("@apollo/client");
const isServer_1 = __importDefault(require("../utils/isServer"));
exports.GET_USER_STATUS = (0, client_1.gql) `
  query UserStatus {
    userStatus {
      advertsCount
      bookmarksCount
      email
      isAuthenticated
      links {
        login
        logout
        register
        account
      }
      name
      roles
      savedSearchesCount
    }
  }
`;
const useGetUserStatus = (options) => {
    const response = (0, client_1.useQuery)(exports.GET_USER_STATUS, Object.assign({ ssr: false }, options));
    if (isServer_1.default || !response.data) {
        return response;
    }
    const refererPathname = window.location.pathname;
    const refererSearch = window.location.search;
    const returnUrl = refererPathname && `?url=${encodeURIComponent(`${refererPathname}${refererSearch}`)}`;
    const { data: { userStatus: { links: { login, logout }, }, }, } = response;
    const modifiedResponse = Object.assign(Object.assign({}, response), { data: response.data && Object.assign(Object.assign({}, response.data), { userStatus: Object.assign(Object.assign({}, response.data.userStatus), { links: Object.assign(Object.assign({}, response.data.userStatus.links), { login: `${login}${returnUrl}`, logout: `${logout}${returnUrl}` }) }) }) });
    return modifiedResponse;
};
exports.useGetUserStatus = useGetUserStatus;
//# sourceMappingURL=user.js.map